import React, {useState} from "react";
import Header from "../Components/Header";
import Sidebar from "../Components/Sidebar";

const Layout = ({children, pageTitle}) => {
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

    return (
        <div>
            <header className="w-full bg-white fixed">
                {/*<Header pageTitle={pageTitle} />*/}
            </header>
            <div className="flex">
                <aside className={`${isSidebarCollapsed ? "w-[4%]" : "w-[16%]"}  h-screen fixed top-0 z-50`}>
                    <Sidebar collapsed={isSidebarCollapsed} setCollapsed={setIsSidebarCollapsed}/>
                </aside>
                <div className={`${isSidebarCollapsed ? 'ml-[4%]' : 'ml-[16%]'} w-full mt-10`}>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Layout;
